import moment from 'moment';



 


        class Tagmanager{
         constructor(params,o){
          
          this.id = o.id;
          this.accountType = "Tagmanager";
            this._types = {}
               
            this.generic = {
              name:"",
              id:"",
              platformId:"",
              description:"",
              subTitle:"",
            }
            this.setParameters(o);
               

            for (var t of  Object.keys(this._types)){
             if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                 if (pt.objectIds.indexOf(this.id) > -1){
                   for (var oid of pt.pivotObjectIds){
                     if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                        params.accounts[pt.pivotAccountId][oid].filter = this.filter;
                       params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                     var model = new this._types[t](params,params.accounts[pt.pivotAccountId][oid]);
                     this.setModelParameters(model);
                     }
                   }
                 }
             }
           }
           }
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }

         
           setName(val){
            this.generic.name = val;
           }
             
           setId(id){
               this.id = id;
               this.generic.id = id;
         }




           
           
         setTruncate(obj){
          if (obj){
          this.truncate = obj;
          this.filtered = (obj && obj[this.accountType] && (obj[this.accountType].indexOf(this.id) > -1)) ? false : true;
          }
        }
           
       
         
       
       setModelParameters(params){
           this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
           this[params.accountType].push(params);
       }
     }
export default Tagmanager;
        